/**
 * 自动生成， 请不要手工修改！
 */

import { AbstractSerializable } from "../../../serialize/AbstractJsonSerializable";
import { Filter } from "../Filter";
import { JsonTypeTagType } from "../../../serialize/JsonTypeTagType";
import { Location } from "../../geolocation/Location";
import { ReviewType } from "../../ipsphere/review/ReviewType";
import { TypeFactory } from "../../../serialize/TypeFactory";

export class ReviewFilter extends AbstractSerializable implements Filter {
  location: Location;
  distance: number;
  reviewType: ReviewType;
  keyword: string;
  targetId: number | string;

  constructor() {
    super();
  }

  public getLocation(): Location {
    return this.location;
  }

  public setLocation(location: Location) {
    this.location = location;
  }

  public getDistance(): number {
    return this.distance;
  }

  public setDistance(distance: number) {
    this.distance = distance;
  }

  public getReviewType(): ReviewType {
    return this.reviewType;
  }

  public setReviewType(reviewType: ReviewType) {
    this.reviewType = reviewType;
  }

  public getKeyword(): string {
    return this.keyword;
  }

  public setKeyword(keyword: string) {
    this.keyword = keyword;
  }

  public getTargetId(): number | string {
    return this.targetId;
  }

  public setTargetId(targetId: number | string) {
    this.targetId = targetId;
  }

  public fillFromJson(json: Object, factory?: TypeFactory) {
    const location = json["location"];
    if (location != null) {
      const convertedLocation0 = new Location();
      convertedLocation0.fillFromJson(location, factory);
      this.setLocation(convertedLocation0);
    }
    const distance = json["distance"];
    if (distance != null) {
      this.setDistance(distance);
    }
    const reviewType = json["reviewType"];
    if (reviewType != null) {
      const convertedReviewType0 = ReviewType[<string>reviewType];
      this.setReviewType(convertedReviewType0);
    }
    const keyword = json["keyword"];
    if (keyword != null) {
      this.setKeyword(keyword);
    }
    const targetId = json["targetId"];
    if (targetId != null) {
      this.setTargetId(targetId);
    }
  }

  public fillToJson(json: Object, includeTypeTag = true) {
    const location = this.getLocation();
    if (location != null) {
      const convertedLocation0 = location.getJson(JsonTypeTagType.NONE);
      json["location"] = convertedLocation0;
    }
    const distance = this.getDistance();
    if (distance != null) {
      json["distance"] = distance;
    }
    const reviewType = this.getReviewType();
    if (reviewType != null) {
      const convertedReviewType0 = ReviewType[reviewType];
      json["reviewType"] = convertedReviewType0;
    }
    const keyword = this.getKeyword();
    if (keyword != null) {
      json["keyword"] = keyword;
    }
    const targetId = this.getTargetId();
    if (targetId != null) {
      json["targetId"] = String(targetId);
    }

    if (includeTypeTag) {
      json["__type"] = "ReviewFilter";
    }
  }

  public getTypeId(): string {
    return "ReviewFilter";
  }

  public getClassName(): string {
    return "com.gong_wei.common.datatype.query.review.ReviewFilter";
  }
}
